module.exports = __webpack_public_path__ + "static/media/p4.f41eb064.csv";